import http from '@paintscout/util/http'

// Lightly check if pdf exists at url already
// Refactored to a promise that tries it's best to return
// something in all error scenarios.
//
// `timeoutMs` is optional and defaults to the historical behaviour, which is no timeout — a HEAD
// against a stalled host then hangs forever. Callers on a clock must pass one: the media migration
// runs this probe per media file inside a 900s Lambda, so an unbounded probe could burn the whole
// segment before any file moved (#22780). A HEAD carries no response body, so `http`'s timeout is a
// real bound here rather than a time-to-headers bound.
export async function urlExists(url: string, timeoutMs?: number) {
  try {
    const res = await http.head(url, timeoutMs ? { timeout: timeoutMs } : undefined)
    return res && res.status === 200 ? url : false
  } catch {
    return false
  }
}

export default urlExists
